//
import json from './data';
import styles from './styles.module.css';
import Lottie from 'lottie-react';

export function Loader (props) {
  return (
    <div className={
      // eslint-disable-next-line
      props.type === 'fullScreen' ? styles.loaderWrapper : ''}>
      <div className={styles.loaderDiv}>
        <Lottie
          animationData={json}
          loop={true}
          autoplay={true}
          style={{ preserveAspectRatio: 'xMidYMid slice' }}
        />
      </div>
    </div>

  );
}
